import { render, staticRenderFns } from "./SolveBook.vue?vue&type=template&id=1a5f7f42&"
import script from "./SolveBook.vue?vue&type=script&lang=js&"
export * from "./SolveBook.vue?vue&type=script&lang=js&"
import style0 from "./SolveBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports